import * as d3 from 'd3'

export default {

  methods: {

    draw_Title(selection) {
      this.drawY = 10

      let circle = this.circle
      let title = this.title

      selection
      .append('text')
      .attr('id', `TITLE_${this.localId}`)
      .attr('x', ()=> {
        let x_ = 0
        if(title.align == 'start') x_ = circle.x - 20
        if(title.align == 'middle') x_ = circle.x + circle.radius
        return x_
      })
      .attr('y', this.drawY + title.tSize*0.36)
      .style('font-size', title.tSize).attr('fill', title.tColor).attr('font-weight', title.tWeight)
      .attr('text-anchor', title.align)
      .text(this.rawData.TITLE)

      this.drawY = this.drawY + 10
    },


    value_Vertical(selection) {
      this.drawY = this.drawY + 10

      let circle = this.circle

      let value = selection
      .append('g')
      .attr('transform', `translate(${circle.x + circle.radius}, ${this.drawY})`)

      let y_ = 0
      this.columns.filter(f=> f.code != 'PROG').forEach((d,i) => {
        value
        .append('text')
        .attr('transform', `translate(-3, ${y_ + this.summary.tSize*0.36})`)
        .style('font-size', this.summary.tSize).attr('fill', this.summary.tColor)
        .attr('text-anchor', 'end')
        .text(`${d.name}:`)

        value
        .append('text') 
        .attr('transform', `translate(3 ,${y_ + d.tSize*0.36})`)
        .style('font-size', d.tSize).attr('fill', d.tColor)
        .attr('text-anchor', 'start')
        .text(this.rawData[d.code].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .call(this.event_Link, d)

        y_ += this.summary.lineHeight
      })
      
      this.drawY = this.drawY + y_
    },


    value_Horizontal(selection) {
      this.drawY = this.drawY + 10

      let value = selection
      .append('g')
      .attr('id', `GROUP_${this.localId}`)
      .attr('transform', `translate(0, ${this.drawY})`)

      let x_ = 0
      this.columns.filter(f=> f.code != 'PROG').forEach((d,i) => {
        value
        .append('text')
        .attr('id', `NAME_${this.localId}_${i}`)
        .attr('x', x_)
        .attr('y', this.summary.tSize*0.36)
        .style('font-size', this.summary.tSize).attr('fill', this.summary.tColor)
        .text(`${d.name}:`)

        x_ = x_ + this.getNode(`#NAME_${this.localId}_${i}`, 'width') + 3
        value
        .append('text')
        .attr('id', `VALUE_${this.localId}_${i}`)
        .attr('x', x_)
        .attr('y', d.tSize*0.36)
        .style('font-size', d.tSize).attr('fill', d.tColor)
        .text(this.rawData[d.code])
        .call(this.event_Link, d)
        x_ = x_ + this.getNode(`#VALUE_${this.localId}_${i}`, 'width') + 10
      })

      d3.select(`#GROUP_${this.localId}`)
      .attr('transform', `translate(${this.circle.x + this.circle.radius - (this.getNode(`#GROUP_${this.localId}`, 'width')/2)}, ${this.drawY})`)
      
      this.drawY = this.drawY + 15
    },

  }
}